<template>
  <footer>
    <nav>
      <a href="#" class="active">
        <fa :icon="['fal','house']" />
      </a>
      <a href="#">
        <fa :icon="['fal', 'file-invoice-dollar']" />
      </a>
      <a href="#">
        <fa :icon="['fal','barcode-read']" />
      </a>
      <a href="#">
        <fa :icon="['fal','comment']" />
      </a>
    </nav>
  </footer>
</template>

<script>
export default {
  
}
</script>

<style lang="scss" scoped>
  footer {
    position: fixed; bottom: 0; left: 0;
    display: block; width: 100%;
    padding: $hmg_large;
    max-width: 1024px;

    nav {
      display: flex; align-items: center;
      justify-content: space-between;
      color: $color-secondary;
      z-index: 100;
      padding: 0 $hmg_mid;
      font-size: 20px;
      width: 100%;

      a {
        @extend %transition_3o;

        &.active {
          color: $color-success
        }
      }
    }
  }
  
</style>